import { createFormAction } from "redux-form-saga";

export const FORM_COMMISSION_FORM = "FORM_COMMISSION_FORM";
export const CommissionFormAction = createFormAction(FORM_COMMISSION_FORM);

export const UPLOAD_PRICE_FORM = "UPLOAD_PRICE_FORM";
export const UploadFormAction = createFormAction(UPLOAD_PRICE_FORM);

